<main class="container-fluid px-0 irembogov-create-template mt-n5 pt-1">
  <!-- Loading State -->
  <irembogov-irembo-loading-circle-spinner
    *ngIf="isCreatingTemplate && currentConfigStep === 0">
  </irembogov-irembo-loading-circle-spinner>

  <ng-container *ngIf="!(isCreatingTemplate && currentConfigStep === 0)">
    <!-- Header Widget -->
    <irembogov-template-configuration-header-widget
      [template]="template"
      [readyForPublish]="readyForSaveAndPublish"
      [isProcessing]="isCreatingTemplate"
      [persistenceStatus]="persistenceStatus"
      [showBuilderVersionToggle]="isOnFormBuilderStep && !showFormPreview"
      [useV2Builder]="useV2Builder"
      (OnPreviewClick)="toggleFormPreview($event)"
      (OnSaveAndClose)="saveAsDraft()"
      (OnPublishTemplate)="publishTemplate()"
      (toggleBuilderVersion)="onToggleBuilderVersion()">
    </irembogov-template-configuration-header-widget>

    <!-- Loading Spinner for data operations -->
    <irembogov-irembo-loading-circle-spinner
      marginTop="8rem"
      *ngIf="template && !templateJsonFormData && isLoadingDetails">
    </irembogov-irembo-loading-circle-spinner>

    <ng-container
      *ngIf="
        (!template || (template && templateJsonFormData)) && !isLoadingDetails
      ">
      <!-- Form Preview -->
      <div
        class="mt-3 p-4 container rounded bg-white"
        *ngIf="showFormPreview && template && templateJsonFormData">
        <irembogov-preview-service-change-request-json-formdata-widget
          class="mx-auto">
        </irembogov-preview-service-change-request-json-formdata-widget>
      </div>

      <!-- Stepper Configuration -->
      <irembogov-template-configuration-stepper
        *ngIf="!showFormPreview"
        [configSteps]="configSteps"
        [selectedIndex]="currentConfigStep"
        (selectionChange)="onStepperChange($event)">
        <cdk-step
          [label]="step.label"
          *ngFor="let step of configSteps; let index = index"
          [hasError]="configSteps[index].hasError"
          [completed]="configSteps[index].isComplete">
          <ng-container
            [ngTemplateOutlet]="getCurrentTemplate(index)"></ng-container>
        </cdk-step>
      </irembogov-template-configuration-stepper>
    </ng-container>
  </ng-container>
</main>

<!-- Templates for each step -->

<!-- Overview Template -->
<ng-template #overview>
  <div class="d-flex">
    <div class="ms-5 me-5 w-70">
      <div class="configuration-metadata-overview-form col-lg-5 mx-auto mt-5">
        <form [formGroup]="overviewForm" (ngSubmit)="onOverviewFormSubmitted()">
          <fieldset [disabled]="isCreatingTemplate">
            <legend class="d-none">Template Metadata</legend>
            <div class="mb-3">
              <h5 class="form-title mb-3">Template Details</h5>

              <div class="form-group">
                <label for="templateName" class="form-label">
                  Template Name *
                  <i
                    class="fa-solid fa-circle-info text-muted"
                    placement="top"
                    ngbTooltip="Name of template"></i>
                </label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="templateName"
                    placeholder="Enter template name"
                    formControlName="name" />
                </div>
                <div
                  class="form-error w-100 small text-danger"
                  *ngIf="
                    overviewForm.get('name')?.touched &&
                    overviewForm.get('name')?.invalid
                  ">
                  <span *ngIf="overviewForm.get('name')?.errors?.['required']"
                    >Template name is required.</span
                  >
                  <span *ngIf="overviewForm.get('name')?.errors?.['minlength']"
                    >Template name must be at least 3 characters.</span
                  >
                </div>
              </div>

              <div class="form-group">
                <label for="trafficClass" class="form-label">
                  Traffic Class
                  <i
                    class="fa-solid fa-circle-info text-muted"
                    placement="top"
                    ngbTooltip="Service traffic classification"></i>
                </label>
                <div class="input-group mb-3">
                  <ng-select
                    formControlName="trafficClass"
                    [items]="trafficClasses"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Choose traffic class"
                    class="form-control">
                  </ng-select>
                </div>
              </div>

              <div class="form-group">
                <label for="serviceType" class="form-label">
                  Service Type
                  <i
                    class="fa-solid fa-circle-info text-muted"
                    placement="top"
                    ngbTooltip="Type of service"></i>
                </label>
                <div class="input-group mb-3">
                  <ng-select
                    formControlName="serviceType"
                    [items]="serviceTypes"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Choose service type"
                    class="form-control">
                  </ng-select>
                </div>
              </div>

              <div class="row d-flex flex-wrap flex-md-nowrap flex-row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label
                      for="templateDescription"
                      class="form-label d-flex justify-content-between align-items-center">
                      <span>
                        Template Description
                        <i
                          class="fa-solid fa-circle-info text-muted"
                          placement="top"
                          ngbTooltip="Summary of template"></i>
                      </span>
                      <button
                        type="button"
                        title="Switch between the Editor and Html"
                        class="btn btn-primary btn-sm"
                        (click)="toggleHtmlEditor()">
                        {{ showHtmlCode ? 'Editor' : 'Html' }}
                      </button>
                    </label>
                    <div class="form-group mb-3">
                      <quill-editor
                        *ngIf="!showHtmlCode"
                        #editor
                        format="html"
                        [modules]="quillConfig"
                        class="custom-editor"
                        formControlName="description"
                        placeholder="Enter service template Summary">
                      </quill-editor>

                      <div>
                        <textarea
                          *ngIf="showHtmlCode"
                          class="htmlCode form-control"
                          rows="10"
                          formControlName="description"></textarea>
                      </div>

                      <small class="w-100 text-muted pt-2">
                        {{
                          getWordCount(overviewForm.get('description')?.value)
                        }}
                        words
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="templateDescription" class="form-label mb-3">
                      Template Description Preview
                    </label>
                    <div class="card p-3 summary-preview">
                      <div
                        class="content-preview"
                        [innerHTML]="
                          overviewForm.get('description')?.value
                        "></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="categoryId" class="form-label">
                  Service Category
                  <i
                    class="fa-solid fa-circle-info text-muted"
                    placement="top"
                    ngbTooltip="Category of service"></i>
                </label>
                <div class="input-group mb-3">
                  <ng-select
                    formControlName="categoryId"
                    [items]="serviceCategoriesBuffer"
                    [virtualScroll]="true"
                    [loading]="isLoadingServiceCategories"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Choose the service category"
                    class="form-control"
                    (search)="onSearchServiceCategory($event)"
                    #select>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm">
                      <strong>{{ item.name }}</strong>
                      <span class="fst-italic">
                        (
                        <span class="text-muted">Keywords:</span>
                        {{
                          item.keywords && item.keywords.length > 15
                            ? (item.keywords | slice : 0 : 15) + '...'
                            : item?.keywords
                        }}
                        )
                      </span>
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  class="form-error w-100 small text-danger"
                  *ngIf="
                    overviewForm.get('categoryId')?.touched &&
                    overviewForm.get('categoryId')?.invalid
                  ">
                  Please select a service category.
                </div>
              </div>

              <div class="form-group">
                <label for="knowledgeBaseUrl" class="form-label">
                  Knowledge base Article Url
                  <i
                    class="fa-solid fa-circle-info text-muted"
                    placement="top"
                    ngbTooltip="Optional URL to knowledge base article for this service"></i>
                </label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="knowledgeBaseUrl"
                    placeholder="Knowledge base Article Url"
                    formControlName="knowledgeBaseUrl" />
                </div>
                <div
                  class="form-error w-100 small text-danger"
                  *ngIf="
                    overviewForm.get('knowledgeBaseUrl')?.touched &&
                    overviewForm.get('knowledgeBaseUrl')?.invalid
                  ">
                  <span
                    *ngIf="
                      overviewForm
                        .get('knowledgeBaseUrl')
                        ?.hasError('invalidUrl')
                    ">
                    Please enter a valid URL.
                  </span>
                  <span
                    *ngIf="
                      overviewForm
                        .get('knowledgeBaseUrl')
                        ?.hasError('invalidProtocol')
                    ">
                    URL must use http or https protocol.
                  </span>
                </div>
              </div>

              <div
                class="form-group application-type d-flex flex-column align-items-start">
                <label for="applicationType" class="form-label">
                  Service Availability
                </label>
                <small class="text-muted mb-3">
                  Select who can apply for this service
                </small>
                <div
                  class="input-group mb-3 d-flex flex-column align-items-start">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="citizenApplication"
                      value="INDIVIDUAL"
                      (change)="onCheckboxChange($event)"
                      [checked]="
                        overviewForm
                          .get('applicantType')
                          ?.value?.includes('INDIVIDUAL')
                      " />
                    <label class="form-check-label" for="citizenApplication">
                      Citizen
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="businessApplication"
                      value="BUSINESS"
                      (change)="onCheckboxChange($event)"
                      [checked]="
                        overviewForm
                          .get('applicantType')
                          ?.value?.includes('BUSINESS')
                      " />
                    <label class="form-check-label" for="businessApplication">
                      Business
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-end">
              <button
                class="btn btn-primary mt-1 mx-auto px-5"
                type="submit"
                [disabled]="isCreatingTemplate || overviewForm.invalid">
                <div
                  *ngIf="isCreatingTemplate"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"></div>
                {{ templateId ? 'Update & Continue' : 'Create & Continue' }}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<!-- Form Builder Template -->
<ng-template #formbuilder>
  <irembogov-irembo-loading-circle-spinner *ngIf="isLoadingDetails">
  </irembogov-irembo-loading-circle-spinner>

  <irembogov-configuration-form-builder
    *ngIf="!isLoadingDetails"
    [changeRequest]="mockChangeRequest"
    [isTemplateMode]="true"
    [template]="template"
    [useV2Builder]="useV2Builder"
    (jsonFormBuilderFormSubmitted)="onStepFormSubmitted($event)">
  </irembogov-configuration-form-builder>
</ng-template>

<!-- Pricing Template -->
<ng-template #pricing>
  <irembogov-configuration-pricing-form
    *ngIf="!isLoadingDetails"
    [changeRequest]="mockChangeRequest"
    [defaultData]="templatePricingData"
    [formFields]="templateFormFields"
    [isTemplateMode]="true"
    [template]="template"
    (OnPricingFormSubmitted)="onStepFormSubmitted($event)">
  </irembogov-configuration-pricing-form>
</ng-template>

<!-- Workflow Template -->
<ng-template #workflow>
  <irembogov-irembo-loading-circle-spinner *ngIf="isLoadingDetails">
  </irembogov-irembo-loading-circle-spinner>

  <irembogov-configuration-workflow-json-editor-form
    *ngIf="!isLoadingDetails"
    [changeRequestJsonWorkflowData]="templateJsonWorkflowData"
    [changeRequest]="mockChangeRequest"
    [formFields]="templateFormFields"
    [isTemplateMode]="true"
    [template]="template"
    (jsonWorkflowFormSubmitted)="onWorkflowStepSubmitted($event)">
  </irembogov-configuration-workflow-json-editor-form>
</ng-template>

<!-- Officer Form Template -->
<ng-template #officerform>
  <irembogov-irembo-loading-circle-spinner *ngIf="isLoadingDetails">
  </irembogov-irembo-loading-circle-spinner>

  <irembogov-configuration-officer-form
    [changeRequest]="mockChangeRequest"
    [changeRequestThirdPartyFormData]="templateThirdPartyFormData"
    [isTemplateMode]="true"
    [template]="template"
    (officerFormSubmitted)="onStepFormSubmitted($event)">
  </irembogov-configuration-officer-form>
</ng-template>

<!-- Translation Template -->
<ng-template #translation>
  <irembogov-irembo-loading-circle-spinner *ngIf="isLoadingDetails">
  </irembogov-irembo-loading-circle-spinner>

  <irembogov-configuration-translation
    *ngIf="!isLoadingDetails && templateJsonWorkflowData"
    [changeRequest]="mockChangeRequest"
    [defaultData]="templateTranslationsData"
    [formFields]="templateFormFields"
    [changeRequestJsonWorkflowData]="templateJsonWorkflowData"
    [isTemplateMode]="true"
    [template]="template"
    (translationFormSubmitted)="onStepFormSubmitted($event)">
  </irembogov-configuration-translation>
</ng-template>

<!-- Journey Mapping Template -->
<ng-template #journeymapping>
  <irembogov-irembo-loading-circle-spinner *ngIf="isLoadingDetails">
  </irembogov-irembo-loading-circle-spinner>

  <irembogov-journeys
    *ngIf="!isLoadingDetails && mockChangeRequest"
    (submitted)="onJourneyMappingStepSubmitted($event)"
    [changeRequest]="mockChangeRequest">
  </irembogov-journeys>
</ng-template>
